import { createMetaManager, MetaConfig, MetaResolver } from 'vue-meta'

export const createMeta = (isSSR?: boolean, config?: MetaConfig, resolver?: MetaResolver) => {
  return createMetaManager(isSSR, config, resolver)
}
